// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let PasswordRecoveryChangeRequest = function (fieldSet)
{
    this.Code = Message.CODE_RECOVERY_CHANGE_REQUEST;
    PFixMessage.call(this, fieldSet);
}
PasswordRecoveryChangeRequest.prototype = Object.create(PFixMessage.prototype);

PasswordRecoveryChangeRequest.prototype.setPassword = function (password)
{
    this.setFieldValue(FieldsFactory.FIELD_PASSWORD, password);
}

PasswordRecoveryChangeRequest.prototype.setLogin = function (login)
{
    this.setFieldValue(FieldsFactory.FIELD_LOGIN, login);
}

PasswordRecoveryChangeRequest.prototype.setKey = function (key)
{
    this.setFieldValue(FieldsFactory.FIELD_KEY, key);
}

PasswordRecoveryChangeRequest.prototype.setAccessToken = function (accessToken)
{
    this.setFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN, accessToken);
}